module.exports = __webpack_public_path__ + "img/add-member.c223bb27.svg";